namespace GeniuzPOS.Points {
    export interface PrPointCampaignForm {
        DowId: Serenity.IntegerEditor;
        DowName: Serenity.StringEditor;
        PointRedeemOneBaht: Serenity.DecimalEditor;
        OnePointbyAmt: Serenity.DecimalEditor;
        CreateBy: Serenity.StringEditor;
        CreateDate: Serenity.DateEditor;
        UpdateBy: Serenity.StringEditor;
        LastUpdate: Serenity.DateEditor;
    }

    export class PrPointCampaignForm extends Serenity.PrefixedContext {
        static formKey = 'Points.PrPointCampaign';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PrPointCampaignForm.init)  {
                PrPointCampaignForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.DateEditor;

                Q.initFormType(PrPointCampaignForm, [
                    'DowId', w0,
                    'DowName', w1,
                    'PointRedeemOneBaht', w2,
                    'OnePointbyAmt', w2,
                    'CreateBy', w1,
                    'CreateDate', w3,
                    'UpdateBy', w1,
                    'LastUpdate', w3
                ]);
            }
        }
    }
}
